<template>
    <div>
        <v-card>
            <v-card-title>Please describe the error</v-card-title>
            <v-card-text>
                <!-- <v-textarea rows="3" outlined v-model="data.errorDescription"></v-textarea> -->
                <div class="ck-editor">
                    <ckeditor
                        :editorUrl="editorURL"
                        v-model="data.errorDescription "
                        :config="{toolbarStartupExpanded:false,startupFocus:true}"
                    ></ckeditor>
                </div>

                <v-btn color="primary" class="cust-btn" @click="sendError">Report Error</v-btn>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "ReportError",
    props: ["data", "onClose"],
    data() { return {}},
    methods: {
        ...mapActions({
            objectQuestion: "resultStore/objectQuestion"
        }),
        sendError() {
            let reqData = {};
            if (!this.data.question.parent_id && this.data.question.parent_id==null) { 
                reqData ={
                test_id: [this.data.test_id],
                question_ids: [this.data.question.id],
                comment: this.data.errorDescription,
                status: "OBJ"
            }}
            else { 
                reqData ={
                test_id: [this.data.test_id],
                question_ids: [this.data.question.parent_id],
                comment: this.data.errorDescription,
                status: "OBJ"
            }}
            this.$root.showLoader = true;
            this.objectQuestion(reqData)
                .then(response => {
                    this.$toasted.success(
                        "Error reported successfully. We will get back to you soon."
                    );
                    this.$root.showLoader = false;
                    this.onClose({ status: false, data: {} });
                })
                .catch(err => {
                    this.$toasted.error(
                        "Could not report Error. Please try again"
                    );
                    this.$root.showLoader = false;
                });
        }
    }
};
</script>